import React from 'react'
import { Navigate } from 'react-router-dom'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  user: state.user,
})

const PrivateRoute = ({ children, user }) => {
  
  return user !== null ? (
    children
  ) : (
    <Navigate to="/login" replace />
  )
}

export default connect(mapStateToProps)(PrivateRoute)
